import clsx from 'clsx';

const PaywallThumbPlaceholder = ({ className }: { className?: string }) => (
  <div className={clsx('flex flex-col gap-1.5 border bg-white p-2', className)}>
    <span className="h-1 w-full rounded-full bg-[#E1E2E6]" />
    <span className="h-1 w-full rounded-full bg-[#E1E2E6]" />
    <span className="h-1 w-3/4 rounded-full bg-[#E1E2E6]" />
    <span className="h-1 w-full rounded-full bg-[#E1E2E6]" />
    <span className="h-1 w-2/3 rounded-full bg-[#E1E2E6]" />
    <span className="h-1 w-full rounded-full bg-[#E1E2E6]" />
  </div>
);

export default PaywallThumbPlaceholder;
